
// PAGES
import configure from './configure.js';

export default [
	configure
];


